// Animated favicon: a revolving gold ring (iWurks360 mark) with "iW" centered.
const SIZE = 64;
const GOLD = "#D4AF37";
const NAVY = "#0B1D3A";

function startAnimatedFavicon() {
  let link = document.getElementById("app-favicon");
  if (!link) {
    link = document.createElement("link");
    link.id = "app-favicon";
    link.rel = "icon";
    document.head.appendChild(link);
  }

  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext("2d");
  const cx = SIZE / 2;
  const cy = SIZE / 2;
  const r = SIZE * 0.40;

  let angle = 0;
  let last = 0;

  function draw(ts) {
    // ~24fps to keep CPU light
    if (ts - last < 42) {
      requestAnimationFrame(draw);
      return;
    }
    last = ts;

    ctx.clearRect(0, 0, SIZE, SIZE);

    // Rounded navy background
    ctx.fillStyle = NAVY;
    const rad = SIZE * 0.22;
    ctx.beginPath();
    ctx.moveTo(rad, 0);
    ctx.arcTo(SIZE, 0, SIZE, SIZE, rad);
    ctx.arcTo(SIZE, SIZE, 0, SIZE, rad);
    ctx.arcTo(0, SIZE, 0, 0, rad);
    ctx.arcTo(0, 0, SIZE, 0, rad);
    ctx.closePath();
    ctx.fill();

    // Faint full track ring
    ctx.strokeStyle = "rgba(212,175,55,0.18)";
    ctx.lineWidth = SIZE * 0.055;
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.stroke();

    // Revolving gold arc (matches the brand's partial ring)
    ctx.strokeStyle = GOLD;
    ctx.lineWidth = SIZE * 0.06;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.arc(cx, cy, r, angle, angle + Math.PI * 0.75);
    ctx.stroke();

    // Centered "iW"
    ctx.fillStyle = GOLD;
    ctx.font = `700 ${SIZE * 0.34}px Georgia, "Times New Roman", serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("iW", cx, cy + SIZE * 0.02);

    link.href = canvas.toDataURL("image/png");

    angle += 0.16;
    if (angle > Math.PI * 2) angle -= Math.PI * 2;
    requestAnimationFrame(draw);
  }

  requestAnimationFrame(draw);
}

if (typeof document !== "undefined") {
  startAnimatedFavicon();
}
